import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_ObjectRemover = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/object-remover',
			name: 'AI Object Remover | Erase Unwanted Objects | Lift',
			description:
				'Remove people, text, watermarks from photos in seconds. AI magic eraser, no watermark. Try Lift now.',
			url: 'https://liftapp.ai/object-remover',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/object-remover#product' },
				{ '@id': 'https://liftapp.ai/object-remover#howto' },
				{ '@id': 'https://liftapp.ai/object-remover#benefits' },
				{ '@id': 'https://liftapp.ai/object-remover#faq' },
				{ '@id': 'https://liftapp.ai/object-remover#why-lift' },
				{ '@id': 'https://liftapp.ai/object-remover#explore-tools' },
				{ '@id': 'https://liftapp.ai/object-remover#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/object-remover#product',
			name: 'AI Object Remover',
			description:
				'Remove people, text, watermarks from photos in seconds. AI magic eraser, no watermark. Try Lift now.',
			url: 'https://liftapp.ai/object-remover',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/object-remover#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Select unwanted objects',
					text: 'Highlight photobombers, text, or blemishes and instantly erase distractions for a perfect shot',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/object-remover#benefits',
			name: 'Who Can Benefit from Lift AI Object Remover?',
			description:
				'Discover how Lift’s AI Object Remover helps online sellers, creators, marketers, and more remove distractions and elevate visual content.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'The Object Remover tool is essential for anyone who appreciates top-notch visuals',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Online sellers can boost their sales with crisp, professional-looking product images',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators and social media stars can enhance their posts, making them more captivating and visually striking, which attracts more followers',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Photographers can streamline their workflow by adjusting lighting and details without spending hours on manual edits',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Businesses and marketers can take their advertising and branding to the next level with eye-catching visuals that make a lasting impact',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Event planners can utilize it to improve event photographs, ensuring that memories are truly unforgettable\n',
				},
				{
					'@type': 'ListItem',
					position: 7,
					name: 'The Object Remover feature seamlessly combines quick solutions with professional-grade outcomes, making it a must-have for both personal and business applications',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.b1857a8f.webp',
				name: 'AI Object Remover Before/After',
				description:
					'AI removed people and objects from beach photo using Lift Object Remover',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/object-remover#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Eraser?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Eraser is a premium tool that lets you remove unwanted objects, text, or people from your photos with just a brush stroke — powered by generative AI.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Eraser work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Using AI inpainting, the tool fills in selected areas based on the surrounding background. Just highlight what you want to erase — whether it’s a logo, blemish, wire, or person — and Lift will make it vanish naturally in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can it remove objects without leaving marks?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Whether it's a photobomber, logo, wire, or blemish — Lift AI Eraser fills in the background naturally after removal. No smudges, cloning artifacts or patchy areas — just clean, seamless results.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/object-remover#why-lift',
			name: 'Why Lift’s AI Object Remover stands out',
			description:
				'Explore why Lift’s AI Object Remover stands out: professional results, smart AI accuracy, cross-platform support, and affordability.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],

			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.dbe0e523.webp',
				name: 'AI Object Remover Before/After',
				description:
					'Tourists removed from photo near Leaning Tower using Lift AI',
			},
		},

		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/object-remover#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/object-remover#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Object Remover',
					item: 'https://liftapp.ai/object-remover',
				},
			],
		},
	],
};
